<mat-chip-set>
  <div class="chip-wrapper flex w-100 wrap">
    <ng-container *ngFor="let item of items; let index = index">
      <mat-chip-row class="flex align-center justify-center" *ngIf="item?.value && (enableCounter? index < 3 : true)" (removed)="removeItem(item)">
        <span class="text-primary pr-1 brd-r brd-primary-light"> {{item.value}} </span>
        <button class="p-1" matChipRemove>
          <app-icon name="cross" size="xxs"></app-icon>
        </button>
      </mat-chip-row>
    </ng-container>
    <mat-chip-row *ngIf="items.length > 3 && enableCounter">
      <span class="text-primary">
        +{{ items.length - 3 }}
      </span>
    </mat-chip-row>
  </div>
</mat-chip-set>

